import React, { useState, useEffect, useRef, useMemo } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { ChangeInventoryStatus, DeleteInventory, GetAllInventories, GetInventoryList, ImportedInventory, ImportedInventorySample, ImportedInventoryValidate, ImportInventoryPrices } from '../../services/company_panel/inventoryService'
import Swal from 'sweetalert2'
import CustomPagination from '../../components/company_panel/common/custompagination'
import { SpecialCharacter, capitalizeFirstLetter, formateDate, getBrandId, getOutletId, removeHyphens, removeSpecialCharacter, getExcelColumnWidths } from '../../helpers/commonFunctions';
import Sorting from '../../components/company_panel/common/sorting';
import Loader from '../../components/company_panel/common/loader'
import StatusFilter from '../../components/company_panel/common/statusFilter'
import { LOADER_TIME, showFilterlist } from '../../utils/Constants'
import CustomRangepicker from '../../components/company_panel/common/rangepicker'
import $ from "jquery";
import { getCompany, checkPermission } from '../../helpers/commonFunctions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import SampleFileCsv from '../../../src/assets/company/inventorySampleFiles/finalSampleFileAug27.csv';
import SampleFileXls from '../../../src/assets/company/inventorySampleFiles/inventorySampleList.xls';
import SampleFileXlsx from '../../../src/assets/company/inventorySampleFiles/inventorySampleListXLSX.xlsx';
import notFound from '../../assets/company/img/no-record-found.png'
import GlobalLoader from '../../components/company_panel/common/globalLoader'

const InventoryList = () => {

    const navigate = useNavigate()
    const params = useParams()
    const location = useLocation()
    const fileInputRef = useRef(null);
    const fileValidateInputRef = useRef(null);
    const [list, setList] = useState([])
    const [statsUpdate, setStatusUpdate] = useState("false")
    const [dataLength, setDataLength] = useState()
    const [itemPerPage, setItemPerPage] = useState(10)
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(Number(params?.id) || 1);
    const [loader, setLoader] = useState(true)
    const [globalLoader, setGlobalLoader] = useState(false);
    const [search, setSearch] = useState({})
    const [globalSearch, setGlobalSearch] = useState("")
    const [resetdate, setResetDate] = useState(false);
    const [validateFileError, setValidateFileError] = useState([]);
    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [isOutletChanged, setIsOutletChanged] = useState(false);

    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
        document.addEventListener('outlet-changed', function () {
            setIsOutletChanged(!isOutletChanged);
        });
    })

    useEffect(() => {
        if (search) {
            setLoader(true)
            setTimeout(() => {
                const formData = new FormData()
                formData.append("page", page)
                formData.append("per_page", itemPerPage)
                formData.append("sort", JSON.stringify(sorting))
                formData.append("search", JSON.stringify(search))
                formData.append("global_search", globalSearch)
                formData.append('brand_id', getBrandId());
                formData.append('outlet_id', getOutletId());
                GetInventoryList(formData).then(data => {
                    setDataLength(data.data.response.count);
                    setList(data && data.data && data.data.response ? data.data.response.rows : [])
                        setLoader(false);
                }).catch(error => {
                    setTimeout(() => {
                        setLoader(false);
                    }, LOADER_TIME);
                    console.log("error ====> ", error);
                })
            }, LOADER_TIME);
        }
    }, [location, statsUpdate, sorting, search, globalSearch, isBrandChanged, isOutletChanged])


    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        setSearch({})
        setResetDate(!resetdate)
        $("#defaultstatus").prop("selectedIndex", 0)
    }

    const closeModel = id => {
        $('#addCardModal').hide()
        $('.modal-backdrop').remove()
        setStatusUpdate(!statsUpdate);

    }

    const openModel = (id, type) => {
        $('#' + id)
            .show()
            .css('opacity', 1)
            .addClass('show')
        $('body').append('<div className="modal-backdrop fade show"></div>')
    }

    // Delete functionality
    function deleteFunction(row) {
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {

                const formdata = new FormData()
                formdata.append("id", row);
                DeleteInventory(formdata).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: data.data.message,
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                        setStatusUpdate(!statsUpdate)
                    }
                }).catch(error => {
                    console.log("deleteError")
                })
            }
        })
    }

    // Change Status functionality
    const ChangeStatus = (row, Num) => {
        const formData = new FormData()
        formData.append("id", row)
        formData.append("status", Num)
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                ChangeInventoryStatus(formData).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: data.data.message,
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                        setStatusUpdate(!statsUpdate)
                    }
                }).catch(error => {
                    console.log("error===>",error)
                })
            }
        })
    }

    // view details functionality
    const viewFunction = (row) => {
        navigate(`/company/raw_materials/inventory/view/${row}`)
    }

    // edit functionality
    const editFunction = (row) => {
        navigate(`/company/raw_materials/inventory/${params.id}/edit/${row.id}`)
    }

    const copyOutletFunction = (row) => {
        navigate(`/company/raw_materials/inventory/${params.id}/edit/${row.id}?copy=true`);
    }

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    // search or filter function
    const prepareSearch = (key, value) => {

        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    }
    // search or filer end

    const headerMapping = {
        "id": "Id",
        "category": "Category Name",
        "sub_category": "Sub Category Name",
        "item_type": "Item type",
        "production_item_id": "Production Item Id",
        "item_name": "Item Name",
        "sku": "SKU",
        "primary_unit_of_measure": "Primary Unit Of Measure",
        "calories_as_per_primary_unit": "Calories As Per Primary Unit",
        "raw_material_price": "Raw Material Price",
        "can_change_later": "Can Change Later",
        "minimum_stock_limit": "Minimum Stock Limit",
        "self_life": "Self Life",
        "transferable": "Transferable",
        "duration": "Duration",
        "allergies": "Allergies",
        "stock" : "Stock(quantity)",
        "created_at" : "created Date",
        "status": "Status"
    };



    const formatValue = (value) => {
        if (value === null || value === undefined || value === "") {
            return 'N/A';
        }
        return value.toString().replace(/_/g, ' ');
    };
    const handleExport = () => {
        setGlobalLoader(true)
        const formData = new FormData()
        formData.append("page", 1)
        formData.append("per_page", dataLength)
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('brand_id', getBrandId());
        formData.append('outlet_id', getOutletId());
        GetInventoryList(formData).then(data => {
            const listData = data && data.data && data.data.response ? data.data.response.rows : [];
            const printData = listData.map((item) => {
                const transformedItem = {};
                const itemName = item?.item_name || 'N/A'
                const stockQuantity = item?.inventory_stocks[0]?.quantity
                const categoryName = item.category && item.category.category ? item.category.category.name : 'N/A';
                const subCategoryName = item.category ? item.category.name : 'N/A';
                const itemType = item?.item_type || 'N/A'
                const uomName = item.uom ? capitalizeFirstLetter(item.uom.uom_code) : 'N/A';
                const createdAt = item?.created_at
                for (const key in headerMapping) {
                    if (headerMapping.hasOwnProperty(key)) {

                        const newKey = headerMapping[key];

                        if (key === "id") {
                            transformedItem[newKey] = item.id;
                        }
                        if (key === "category") {
                            transformedItem[newKey] = capitalizeFirstLetter(categoryName);
                        }
                        else if (key === "sub_category") {
                            transformedItem[newKey] = capitalizeFirstLetter(subCategoryName);
                        }
                        else if (key === "item_type") {
                            transformedItem[newKey] = formatValue(removeHyphens(capitalizeFirstLetter(itemType)));
                        }
                        else if (key === "production_item_id") {
                            transformedItem[newKey] = item.production_item_id;
                        }  
                        else if (key === "item_name") {
                            transformedItem[newKey] = capitalizeFirstLetter(itemName);
                        }
                        else if (key === "sku") {
                            transformedItem[newKey] = item.sku;
                        }    
                        else if(key === "primary_unit_of_measure") {
                            transformedItem[newKey] = uomName;
                        }
                        else if(key === "calories_as_per_primary_unit") {
                            transformedItem[newKey] = item.calories_as_per_primary_unit;
                        }
                        else if (key === "raw_material_price") {
                            transformedItem[newKey] = item.raw_material_price;
                        }    
                        else if (key === "can_change_later") {
                            transformedItem[newKey] = item.can_change_later;
                        }    
                        else if (key === "minimum_stock_limit") {
                            transformedItem[newKey] = item.minimum_stock_limit;
                        }    
                        else if (key === "self_life") {
                            transformedItem[newKey] = item.self_life;
                        }
                        else if (key === "transferable") {
                            transformedItem[newKey] = item.transferable;
                        }
                        else if (key === "duration") {
                            transformedItem[newKey] = item.duration;
                        }
                        else if (key === "allergies") {
                            transformedItem[newKey] = item.allergies ? (Array.isArray(item.allergies) ? item.allergies.join(',') : '' ) : '';
                        }
                        else if (key === "stock") {
                            transformedItem[newKey] = (stockQuantity);
                        }
                        else if(key === "created_at") {
                            transformedItem[newKey] = formateDate(createdAt);
                        }
                        else if(key === "status") {
                            transformedItem[newKey] = item.status;
                        }
                    }
                }
                return transformedItem;
            });
        const ws = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
        ws['!cols'] = getExcelColumnWidths(printData, Object.values(headerMapping));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, 'inventory.xlsx');
        setGlobalLoader(false);
    }).catch(error => {
        setGlobalLoader(false);
        // setTimeout(() => {
        //     setGlobalLoader(false);
        // }, LOADER_TIME);
        console.log("error ====> ", error);
    })
    };



    // ---- Import prices ------------------------------------------------------
    // Two columns, parsed and checked here so a bad sheet never reaches the API.
    const PRICE_COLUMNS = [
        { field: 'sku', label: 'sku', header: 'SKU' },
        { field: 'price', label: 'price', header: 'Price' },
    ];

    // Headers match on the exact wording, case and spacing aside: "Recipe SKU"
    // and "recipe sku" both pass, "recipe_sku" does not.
    const normalizeHeader = (header) => String(header || '').trim().toLowerCase().replace(/\s+/g, ' ');

    const priceFileInputRef = useRef(null);

    const triggerPriceFileInput = () => {
        if (priceFileInputRef.current) {
            priceFileInputRef.current.click();
        }
    };

    const showPriceError = (html) => {
        Swal.fire({
            customClass: 'swal-wide',
            icon: 'error',
            title: 'Invalid file',
            html,
            confirmButtonColor: '#2f9bff',
        });
    };

    // Not a blank template: the sheet comes back with every raw material in the
    // brand and the price it has now, so only the price column has to be edited
    // before it is uploaded again. The SKU / Price headers are the two the
    // import matches on; the name column is there for whoever fills it in.
    const [priceSampleLoading, setPriceSampleLoading] = useState(false);

    const downloadPriceSample = () => {
        setPriceSampleLoading(true)
        // get-all-inventories returns every active raw material in one go, so
        // there is no page size to guess at. The listing's filters ride along so
        // the sheet covers exactly the raw materials on screen.
        const formData = new FormData()
        formData.append('brand_id', getBrandId());
        formData.append('outlet_id', getOutletId());
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        GetAllInventories(formData).then(data => {
            const rows = data?.data?.response?.rows || [];
            if (!rows.length) {
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'error',
                    title: 'There are no raw materials to export',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true,
                    position: 'top-right',
                })
                return
            }
            const sheet = [
                ['Raw Material Name', ...PRICE_COLUMNS.map(column => column.header)],
                ...rows.map(row => ([
                    row?.item_name ? capitalizeFirstLetter(row.item_name) : '-',
                    row?.sku || '-',
                    // A real number so the column can be edited as a price. This
                    // endpoint does not return raw_material_price today, so the
                    // cell is left blank to be filled in rather than showing 0.
                    row?.raw_material_price == null || row?.raw_material_price === '' ? ''
                        : (isNaN(Number(row.raw_material_price)) ? row.raw_material_price : Number(row.raw_material_price)),
                ])),
            ];
            const ws = XLSX.utils.aoa_to_sheet(sheet);
            ws['!cols'] = [{ wch: 34 }, { wch: 20 }, { wch: 12 }];
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Prices');
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            saveAs(new Blob([excelBuffer], { type: 'application/octet-stream' }), 'update-raw-material-prices-sample.xlsx');
        }).catch(error => {
            console.log("Error---->", error);
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: error?.response?.data?.message || 'Could not export the raw materials',
                showConfirmButton: false,
                timer: 5000,
                toast: true,
                position: 'top-right',
            })
        }).finally(() => {
            setPriceSampleLoading(false)
        })
    };

    const handlePriceFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (event) => {
            e.target.value = null;
            let sheetRows = [];
            let headers = [];
            try {
                const workbook = XLSX.read(new Uint8Array(event.target.result), { type: 'array' });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                const raw = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '', blankrows: false });
                headers = raw[0] || [];
                sheetRows = XLSX.utils.sheet_to_json(sheet, { defval: '', blankrows: false });
            } catch (error) {
                console.log("Error---->", error);
                showPriceError('This file could not be read. Please upload a valid xls or xlsx file.');
                return;
            }

            const headerMap = {};
            const missing = [];
            PRICE_COLUMNS.forEach(column => {
                const match = headers.find(header => normalizeHeader(header) === column.label);
                if (match === undefined) missing.push(column.label);
                else headerMap[column.field] = match;
            });
            if (missing.length) {
                showPriceError(`These column(s) are missing: <b>${missing.join(', ')}</b>`);
                return;
            }
            if (!sheetRows.length) {
                showPriceError('This file has no rows to import.');
                return;
            }

            const errors = [];
            const prices = [];
            sheetRows.forEach((sheetRow, index) => {
                // +2: the header is row 1, so the first data row is row 2 in the sheet.
                const rowNumber = index + 2;
                const sku = String(sheetRow[headerMap.sku] ?? '').trim();
                const price = String(sheetRow[headerMap.price] ?? '').trim();

                if (!sku) errors.push(`Row ${rowNumber}: sku is required`);
                if (!price || isNaN(Number(price)) || Number(price) < 0) errors.push(`Row ${rowNumber}: price must be a number of 0 or more`);

                prices.push({ sku, price: Number(price) });
            });

            if (errors.length) {
                const shown = errors.slice(0, 10).join('<br/>');
                const more = errors.length > 10 ? `<br/><b>and ${errors.length - 10} more</b>` : '';
                showPriceError(`${shown}${more}`);
                return;
            }

            setGlobalLoader(true);
            ImportInventoryPrices({
                brand_id: getBrandId(),
                prices: JSON.stringify(prices),
            }).then(response => {
                const success = response.data.status === 1 || response.data.status === '1';
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: success ? 'success' : 'error',
                    title: response.data.message,
                    showConfirmButton: false,
                    // The import reports what it did, so give it time to be read.
                    timer: 5000,
                    toast: true,
                    position: 'top-right',
                });
                if (success) setStatusUpdate(!statsUpdate);
            }).catch(error => {
                console.log("Error---->", error);
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'error',
                    title: error?.response?.data?.message || 'Could not import prices',
                    showConfirmButton: false,
                    timer: 5000,
                    toast: true,
                    position: 'top-right',
                });
            }).finally(() => {
                setGlobalLoader(false);
            });
        };
        reader.readAsArrayBuffer(file);
    };

    const triggerFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        let company_detail = JSON.parse(localStorage.getItem("company_detail"));
        if (!file) return;
        const formData = new FormData();
        formData.append("file", file);
        formData.append("brand_id", localStorage.getItem("brand_id"))
        formData.append("company_id", company_detail.id)
        ImportedInventory(formData).then((response) => {
            setStatusUpdate(!statsUpdate);
            e.target.value = null;
            if (response.data.status === 1 || response.data.status === '1') {
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000,
                    toast: true,
                    position: 'top-right',
                })
            } else if (response.data.status === 0 || response.data.status === '0') {
                if (Array.isArray(response.data.error)) {
                    setValidateFileError(response.data.error)
                    openModel('addCardModal', 'add');
                } else {
                    Swal.fire({
                        customClass: 'swal-wide',
                        icon: 'error',
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 5000,
                        toast: true,
                        position: 'top-right',
                    })
                }
            }
        }).catch((error) => {
            console.log("Error---->", error);
        })
    }

    return (
        <>
            {globalLoader && <GlobalLoader />}
            <div className="animation_fade">
                <div className='filter-header d-flex justify-content-between align-items-center mb-4'>
                    <div className='page-header-left'>
                        <h4>Inventory List</h4>
                    </div>
                    <div className='d-flex gap-3 align-items-center'>
                    {checkPermission('store_end_of_inventories', 'view') ?
                        <button className="btn btn-primary mr-2"  onClick={() => navigate(`/company/raw_materials/inventory/end_of_day/history/list/1`)}>Inventory End Of Day</button>
                        : null}
                        {/* The spreadsheet actions share one menu, split by what they load */}
                        <div className="dropdown">
                            <button className="btn btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Bulk Actions
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end">
                                <li><h6 className="dropdown-header">Inventory</h6></li>
                                <li><div className="dropdown-item cp" onClick={triggerFileInput}><i className="ti ti-upload" aria-hidden="true"></i> Import</div></li>
                                <li><div className="dropdown-item cp" onClick={handleExport}><i className="ti ti-download" aria-hidden="true"></i> Export</div></li>
                                <li><a className="dropdown-item" href={SampleFileCsv} download><i className="ti ti-file" aria-hidden="true"></i> Sample csv file</a></li>
                                <li><a className="dropdown-item" href={SampleFileXls} download><i className="ti ti-file" aria-hidden="true"></i> Sample xls file</a></li>
                                <li><a className="dropdown-item" href={SampleFileXlsx} download><i className="ti ti-file" aria-hidden="true"></i> Sample xlsx file</a></li>
                                <li><hr className="dropdown-divider" /></li>
                                <li><h6 className="dropdown-header">Prices</h6></li>
                                <li><div className="dropdown-item cp" onClick={triggerPriceFileInput}><i className="ti ti-upload" aria-hidden="true"></i> Import</div></li>
                                <li><div className="dropdown-item cp" onClick={downloadPriceSample}><i className="ti ti-file" aria-hidden="true"></i> {priceSampleLoading ? 'Preparing...' : 'Export sample file'}</div></li>
                            </ul>
                        </div>
                        <input type="file" accept=".xls,.xlsx,.csv" onChange={handleFileChange} ref={fileInputRef} style={{ display: 'none' }}
                        />
                        <input type="file" accept=".xls,.xlsx" onChange={handlePriceFileChange} ref={priceFileInputRef} style={{ display: 'none' }}
                        />
                        <div className='page-header-right ms-auto'>
                            {checkPermission('store_inventories', 'add') ?
                                <button className="btn btn-primary ms-2" onClick={() => navigate(`/company/raw_materials/inventory/add`)}>Create Inventory</button>
                                : ''
                            }
                        </div>
                    </div>
                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20'>
                        <div className='filter-header d-flex justify-content-between align-items-center'>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="form-group mb-0 rangepicker_container">
                                    <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                </div>
                            </div>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="date-input">
                                    <CustomRangepicker GetDateRange={(e) => { prepareSearch("created", e) }} resetdate={resetdate} />
                                </div>
                                <StatusFilter data={showFilterlist} prepareSearch={prepareSearch} />
                                <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary mr-2">Reset Filter</button>
                            </div>
                        </div>
                    </div>
                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                                <thead>
                                    <tr>
                                        <th width="5%">
                                            <div className='d-inline-flex align-items-start'>
                                                <span className='me-2'>Id</span>
                                                <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="id" />
                                            </div>
                                        </th>
                                        <th width="10.5%">
                                            <div className='sorting_column'>
                                                <span>Item</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="item_name" />
                                            </div>
                                        </th>
                                        <th width="10.5%">
                                            <div>
                                                <span>SKU</span>
                                                {/* <Sorting sort={sorting} handleSort={handleSort} column="item_name" /> */}
                                            </div>
                                        </th>
                                        <th width="12.5%">
                                            <div className='sorting_column'>
                                                <span>Stock (quantity)</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="stock" />
                                            </div>
                                        </th>
                                        <th width="12.5%">
                                            <span>Category</span>
                                        </th>
                                        <th width="12.5%">
                                            <span>Sub category</span>
                                        </th>
                                        <th width="12.5%">
                                            <div className='sorting_column'>
                                                <span>Item type</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="item_type" />
                                            </div>
                                        </th>
                                        <th width="12.5%">
                                            <div className='sorting_column'>
                                                <span>Primary unit of measure</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="primary_unit_of_measure" />
                                            </div>
                                        </th>

                                        <th className="created_head" width="13.5%">
                                            <div className='sorting_column'>
                                                <span>Created Date</span>
                                                <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="created_at" />
                                            </div>
                                        </th>
                                        <th className='status_head' width="12.5%">Status</th>
                                        <th className='action_head text-end' width="12.5%">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={12}><Loader /></td>
                                        </tr> : <>
                                            {list.length ? list.map((row, i) => (
                                                <tr key={i}>
                                                    <td>{row?.id}</td>
                                                    <td>{capitalizeFirstLetter(row?.item_name)}</td>
                                                    <td>{row?.sku}</td>
                                                    <td>{row?.inventory_stocks[0]?.quantity}</td>
                                                    <td>{row?.category?.category?.name ? capitalizeFirstLetter(row?.category?.category?.name) : 'N/A'}</td>
                                                    <td>{capitalizeFirstLetter(row?.category?.name)}</td>
                                                    <td>{capitalizeFirstLetter(removeHyphens(row?.item_type))}</td>
                                                    <td>{row?.uom?.uom}</td>
                                                    <td>{row?.created_at ? formateDate(row.created_at) : "N/A"}</td>

                                                    <td>
                                                        <div className="form-check form-switch e_none cp" onClick={() => { ChangeStatus(row.id, row.status == 1 ? 0 : 1) }}>
                                                            <input className="form-check-input" type="checkbox" id="status-change" name="status" defaultChecked={row.status} />
                                                            <label className="form-check-label" htmlFor="status-change"></label>
                                                        </div>
                                                    </td>
                                                    <td className='text-end'>
                                                        <div className="dropdown  d-inline-block">
                                                            <button className="btn btn-icon btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className='ti ti-dots-vertical'></i>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                            {checkPermission('store_inventories', 'view') ?
                                                                <li><div className='dropdown-item' onClick={() => { viewFunction(row?.id) }}><i className="ti ti-eye" aria-hidden="true"></i> View details</div></li>
                                                                : '' }
                                                                {checkPermission('store_inventories', 'edit') ?
                                                                    <li><div className='dropdown-item' onClick={() => { editFunction(row) }}><i className="ti ti-edit" aria-hidden="true"></i> Edit</div></li>
                                                                    : ''}
                                                                {checkPermission('store_inventories', 'delete') ?
                                                                    <li> <div className='dropdown-item' onClick={() => { deleteFunction(row.id) }}><i className="ti ti-trash" aria-hidden="true"></i> Delete</div></li> :
                                                                    ''}
                                                                {checkPermission('store_inventories', 'add') ?
                                                                <li> <div className='dropdown-item' onClick={() => { copyOutletFunction(row) }}><i className="ti ti-copy" aria-hidden="true"></i> Copy inventory</div></li>
                                                                : '' }

                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )) : <tr><td colSpan={11} className="text-center">
                                                <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                <p>No records</p>
                                            </td></tr>}</>}
                                </tbody>
                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "outlet-management", path: "/company/raw_materials/inventory/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
            {/* Modal */}
            <div
                className="modal fade"
                id="addCardModal"
                aria-labelledby="addCardModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addCardModalLabel">
                                Some error are found, Please correct the field according to sample files.
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={e => closeModel('addCardModal')}
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <table className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">Sr. No. </th>
                                        <th scope="col">Sheet Row No.</th>
                                        <th scope="col">Errors</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {validateFileError.map((err, i) => (
                                        <tr key={i}>
                                            <th scope="row">{i + 1}</th>
                                            <th scope="row">Row No. {err.index + 1}</th>
                                            <td className='text-danger'>{err.error}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-right"
                hideProgressBar={false}
                autoClose={true | 1000}
                newestOnTop={true}
                closeOnClick={false}
                draggable={false}
                rtl={false}
            />
        </>
    );
}

export default InventoryList;